<template>
  <v-container>
    <v-card>
      <v-tabs v-model="tab" vertical dense>
        <v-tab dense>
          <v-badge
            v-if="Status.Tersedia.count != 0"
            dense
            color="pink"
            :content="Status.Tersedia.count"
            >Tersedia</v-badge
          >
          <div v-else>Tersedia</div>
        </v-tab>
        <v-tab>
          <v-badge
            v-if="Status.Dipakai.count != 0"
            dense
            color="pink"
            :content="Status.Dipakai.count"
            >Dipakai</v-badge
          >
          <div v-else>Dipakai</div>
        </v-tab>
        <v-tab>
          <v-badge
            v-if="Status.Dicairkan.count != 0"
            dense
            color="pink"
            :content="Status.Dicairkan.count"
            >Dicairkan</v-badge
          >
          <div v-else>Dicairkan</div>
        </v-tab>
        <v-tab>
          <v-badge
            v-if="Status.MenungguPencairan.count != 0"
            dense
            color="pink"
            :content="Status.MenungguPencairan.count"
            >wait</v-badge
          >
          <div v-else>wait</div>
        </v-tab>
        <v-tab>
          <v-badge
            v-if="Status.Hangus.count != 0"
            dense
            color="pink"
            :content="Status.Hangus.count"
            >Hangus</v-badge
          >
          <div v-else>Hangus</div>
        </v-tab>
        <v-tab>
          <v-badge
            v-if="Status.Kadaluarsa.count != 0"
            dense
            color="pink"
            :content="Status.Kadaluarsa.count"
            >Kadaluarsa</v-badge
          >
          <div v-else>Kadaluarsa</div>
        </v-tab>

        <v-tabs-items v-if="RenderUnits" v-model="tab">
          <v-tab-item>
            <Tiket :Tiket="Status.Tersedia.data" />
          </v-tab-item>
          <v-tab-item>
            <Tiket :Tiket="Status.Dipakai.data" />
          </v-tab-item>
          <v-tab-item>
            <Tiket :Tiket="Status.Dicairkan.data" />
          </v-tab-item>
          <v-tab-item>
            <Tiket :Tiket="Status.MenungguPencairan.data" />
          </v-tab-item>
          <v-tab-item>
            <Tiket :Tiket="Status.Hangus.data" />
          </v-tab-item>
          <v-tab-item>
            <Tiket :Tiket="Status.Kadaluarsa.data" />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import Tiket from '@/components/Tiket.vue';
export default {
  components: {
    Tiket
  },
  name: 'TabTiket',
  props: {
    id_app_user: Number
  },
  data() {
    return {
      RenderUnits: true,
      tab: null,
      Status: {
        Tersedia: [],
        Dipakai: [],
        Dicairkan: [],
        MenungguPencairan: [],
        Hangus: [],
        Kadaluarsa: []
      }
    };
  },
  async mounted() {
    this.Status.Tersedia = await this.GetTiketStatus(1);
    this.Status.Dipakai = await this.GetTiketStatus(2);
    this.Status.Dicairkan = await this.GetTiketStatus(3);
    this.Status.MenungguPencairan = await this.GetTiketStatus(4);
    this.Status.Hangus = await this.GetTiketStatus(5);
    this.Status.Kadaluarsa = await this.GetTiketStatus(6);
  },

  methods: {
    async GetTiketStatus(id_mst_tiket_status) {
      const response = await this.$req.get(this.$root.$baseapi.tiket+'/tiket/v3/tiket', {
        params: {
          id_app_user: this.id_app_user,
          id_mst_tiket_status: id_mst_tiket_status
        }
      });

      return response.data;
    }
  }
};
</script>
